import { Job } from 'builder/modules/jobTracking'

export const formatInterviewTitle = (job: Partial<Job>) => {
  return [job?.title || 'N/A', job?.company].filter(Boolean).join(' at ')
}
